import { useMutation } from '@tanstack/react-query'

import { createFreeeAccountForPoints } from '@src/api'
import { DefaultApiPostFreeeAccountForPointsRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useCreateFreeeAccountForPoints = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiPostFreeeAccountForPointsRequest) =>
      createFreeeAccountForPoints(axiosInstance, params),
  })
}
